'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ = require('../../../../');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
//import './table-cell.css';


var GeckoTableCellBase = function (_Component) {
    _inherits(GeckoTableCellBase, _Component);

    function GeckoTableCellBase() {
        _classCallCheck(this, GeckoTableCellBase);

        return _possibleConstructorReturn(this, (GeckoTableCellBase.__proto__ || Object.getPrototypeOf(GeckoTableCellBase)).apply(this, arguments));
    }

    _createClass(GeckoTableCellBase, [{
        key: 'findInObject',
        value: function findInObject(value, key) {
            if (typeof key === 'string') {
                var keys = key.split('.');
                var found = false;
                //Filter through (nested) object value
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = keys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var _key = _step.value;

                        //Check key is on object
                        if (!value[_key]) break;
                        //Update object reference
                        value = value[_key];
                        found = true;
                    }
                    //Return final value
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }

                return found ? value : '';
            }
            return null;
        }
    }, {
        key: 'cell',
        value: function cell() {
            return this.props.col;
        }
    }, {
        key: 'renderValue',
        value: function renderValue() {
            var row = this.props.row;

            var value = this.findInObject(row, this.cell().key);

            // Run custom value render 
            if (this.cell().render) {
                value = this.cell().render(value, row, this.cell(), this.props.index);
            }

            if (this.cell().renderComponent) {
                value = this.cell().renderComponent(value, row, this.cell(), this.props.index);
            }

            return value;
        }
    }, {
        key: 'render',
        value: function render() {
            return null;
        }
    }]);

    return GeckoTableCellBase;
}(_react.Component);

GeckoTableCellBase.propTypes = {
    col: _propTypes2.default.shape(_.GeckoTableCellModel).isRequired
};

exports.default = GeckoTableCellBase;